module.exports = __webpack_public_path__ + "img/v210-min.6a62ae16.png";